import React, { useState, useEffect, useRef } from 'react';
import {FaPlay, FaPause} from 'react-icons/fa6';
import {StyledAudio, AudioWrapper} from "./audio-div.style";
interface AudioProps {
  src?: string | null;
  duration?: number | null;
}

// const PauseButton = ({id=''}) => {
//   return (
//       <svg id={id} className={'pause-button transition-escape'} width="10" height="10" viewBox="0 0 10 10"
//            xmlns="http://www.w3.org/2000/svg">
//         <rect width="3" height="10" stroke="currentColor" strokeWidth=".7" fill="none"
//               transform="translate(1, 1), scale(.8, .8) "/>
//         <rect x="7" width="3" height="10" stroke="currentColor" strokeWidth=".7" fill="none"
//               transform="translate(1, 1), scale(.8, .8) "/>
//       </svg>
//   );
// }
//
// export const PlayButton = ({id=''}) => {
//   return (
//       <svg id={id} className={'play-button transition-escape'} width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
//         <path d="M0 0L10 5L0 10V0Z" stroke="currentColor" strokeWidth=".7" fill="none" transform="translate(1, 1), scale(.8, .8) " />
//       </svg>
//   );
// }



const PostAudio: React.FunctionComponent<AudioProps> = ({ src, duration }) => {
  if (!src) {
    return <div><FaPlay/>{duration ?? 10}<span className='minutes'> </span>m<span className='minutes'>in</span></div>
  }
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef<HTMLAudioElement>(null);

  useEffect(() => {
    const audio = audioRef.current;

    if (audio) {
      // Clean up audio when the component unmounts
      return () => {
        audio.pause();
      };
    }
  }, []);

  const togglePlayPause = () => {
    const audio = audioRef.current;

    if (audio) {
      if (isPlaying) {
        audio.pause();
      } else {
        audio.play();
      }

      setIsPlaying(!isPlaying);
    }
  };

  useEffect(() => {
    const audio = audioRef.current;

    if (audio) {
      audio.addEventListener('ended', togglePlayPause);
      return () => {
        audio.removeEventListener('ended', togglePlayPause);
      };
    }
  }, [src, isPlaying]);
  const lightName = 'linear-wipe wipe-light';
  const darkName = 'linear-wipe wipe-dark';
  // const desc = duration ? <PostDate><span>Listening time:</span> {duration} {duration === 1 ? 'minute' : 'minutes'}</PostDate>  : <PostDate>Start listening</PostDate>


  return (
    <AudioWrapper onClick={togglePlayPause} >
      <audio ref={audioRef} src={src}></audio>
    <StyledAudio className={isPlaying ? lightName + ' playing' : lightName}>
      <FaPause id='pause-button'/><FaPlay id='play-button'/>{duration ?? 10}<span className='minutes'> </span>m<span className='minutes'>in</span>
    </StyledAudio>
    <StyledAudio className={isPlaying ? darkName + ' playing' : darkName}>
      <FaPause id='pause-button'/><FaPlay id='play-button'/>
    </StyledAudio>
    </AudioWrapper>
  );
};

export default PostAudio;
